/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable camelcase */
import * as React from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/style.css';

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({ className, classNames, showOutsideDays = true, ...props }: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={className}
      classNames={{
        ...classNames,
        caption_label: 'pl-4 pt-3',
        selected: 'bg-[#f8b00798] rounded-xl',
        day: 'hover:bg-[#f8b0075f] rounded-xl',
        chevron: 'fill-white',
        today: 'text-primary',
      }}
      {...props}
    />
  );
}
Calendar.displayName = 'Calendar';

export { Calendar };
